import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const faqs = [
  { q: "Do you offer both ceremony and reception spaces?", a: "Yes. Padua Weddings offers beautiful spaces for ceremonies, receptions, portraits, and private celebrations." },
  { q: "Do you offer catering and bar service?", a: "Yes. Catering and bar service options are available and can be discussed during your tour." },
  { q: "Where is Padua Weddings located?", a: "Padua Weddings is located in Claremont, California, tucked into the foothills at 4467 Padua Ave." },
  { q: "How do we schedule a tour?", a: "Click the Schedule a Private Tour button and complete the inquiry form. Our team will follow up with available tour options." }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <section className="py-24 bg-padua-ivory">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif text-padua-charcoal mb-6">Frequently Asked Questions</h2>
          <div className="w-16 h-0.5 bg-padua-gold mx-auto" />
        </div>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-padua-cream/30 rounded-xl border border-padua-gold/10 overflow-hidden" >
              <button 
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)} 
                className="w-full px-8 py-6 text-left flex items-center justify-between" 
              >
                <span className="font-serif text-xl text-padua-charcoal font-medium pr-4">{faq.q}</span>
                <SafeIcon name={openIndex === index ? "ChevronUp" : "ChevronDown"} className="w-5 h-5 text-padua-gold flex-shrink-0" />
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}>
                    <div className="px-8 pb-6 text-padua-charcoal/80 leading-relaxed font-light border-t border-padua-gold/5 pt-4">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;